import { updates } from '@/mocks/homeData';

const tagColorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-700',
  secondary: 'bg-secondary-100 text-secondary-700',
};

export default function Updates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
            最新快讯
          </h2>
          <p className="mt-3 text-sm text-foreground-600">
            实时追踪娱乐圈和网红圈的最新动态
          </p>
        </div>
        <div className="max-w-3xl mx-auto">
          {updates.map((item, i) => (
            <div
              key={i}
              className="relative pl-8 pb-8 last:pb-0 border-l-2 border-background-200 last:border-transparent"
            >
              <div className="absolute left-0 top-0 -translate-x-1/2 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-background-50"></div>
              <div className="flex flex-wrap items-center gap-2 mb-1.5">
                <span className={`inline-block px-2 py-0.5 text-xs font-medium rounded-full whitespace-nowrap ${tagColorMap[item.tagColor] || tagColorMap.primary}`}>
                  {item.tag}
                </span>
                <span className="text-xs text-foreground-500 whitespace-nowrap">
                  {item.date} {item.time}
                </span>
              </div>
              <p className="text-sm md:text-base text-foreground-800 leading-relaxed">
                {item.title}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}